/* ••[1]••••••••••••••••••••••••• spotlight.ts •••••••••••••••••••••••••••••• */

import { Component, CustomElement } from "../../core/CustomElement";
import { Spotlight, validatedSpotlight } from "../../core/types/Spotlight";
import { validateJsonStringified } from "../../core/utilities";
import CCCDialog from "../dialog/dialog";

// Components
import "../dialog/dialog";

@Component("ccc-spotlight-dialog", {
  template: require("./template.html").default,
  style: require("./styles.scss").default,
  viewModel: require("./spotlightDialogVm"),
  observedAttributes: ["spotlight"],
})
export default class CCCSpotlightDialog extends CustomElement {
  attributeChangedCallback(
    attr: string,
    _oldValue: unknown,
    newValue: unknown
  ): void {
    switch (attr) {
      case "spotlight": {
        const newValueObj: Spotlight = validateJsonStringified(
          newValue as string
        );

        this.viewModel.spotlight(validatedSpotlight(newValueObj));
        break;
      }
    }
  }

  /* ••[2]•••••••••• Implementation ••••••••••••••• */
  public set spotlight(value: Spotlight) {
    if (typeof value === "object") {
      this.viewModel.spotlight(validatedSpotlight(value));
    }
  }

  public open(): void {
    (this.shadowDom.querySelector(".spotlight-dialog") as CCCDialog).open();
  }
}

// https://www.figma.com/file/8dAQp4d1MS6YQt44jWZSYu/Vanilla?node-id=1087%3A5069
